module.exports = __webpack_public_path__ + "static/media/web-development.57895e0b.svg";